import React, { useState } from "react"

import Slider from 'react-input-slider';
import "./customSlide.scss"
import Building from "./Building.svg"
import Property from "./Property.svg"
import Tribal from "./Tribal.svg"

import TribalLabel from "./labels/PropertyWide.png"
import PropertyLabel from "./labels/On-Property.png"
import BuildingLabel from "./labels/Building-Room.png"


const CustomSlider = () => {

    const [state, setState] = useState({ y: 1 });
    return (
        <div className="customSlide" style={
            state.y < 25 ? {
                "--scale": 1 + ((((state.y) * (state.y)) / (25 * 25)) * 6),
                "--tanslateX": `${(((state.y)) / (25)) * 55}px`,
                "--tanslateY": `${(((state.y)) / (25)) * 21}px`,

                "--buildingLOpacity": 0,
                "--buildingOpacity": 0,
                "--propertyOpacity": (((state.y) * (state.y)) / (25 * 25)),
                "--tribalOpacity": 1 - (((state.y) * (state.y)) / (25 * 25)),
            } as React.CSSProperties : {
                "--scale": 7 + (((state.y - 25) / 25) * 20),
                "--tanslateX": `${55 + ((((state.y - 25) * (state.y - 25)) / (25 * 25)) * 12)}px`,
                "--tanslateY": `${21 + (((state.y - 25) * (state.y - 25) / (25 * 25)) * 2)}px`,
                "--buildingOpacity": (((state.y - 25) * (state.y - 25)) / (25 * 25)),
                "--propertyOpacity": 1,
                "--tribalOpacity": 0,


            } as React.CSSProperties}>
            <img className={"tribal"} src={Tribal} alt="" />
            <img className={"property"} src={Property} alt="" />
            <img className={"building"} src={Building} alt="" />

            <img className={"label tribal"} src={TribalLabel} alt="" />
            <img className={"label property"} src={PropertyLabel} alt="" />
            <img className={"label building"} src={BuildingLabel} alt="" />



            <div className="slider">

                <Slider
                    styles={{
                        track: {
                            backgroundColor: '#0A003C',
                            height: "620px",
                            width: "16px",
                        },
                        active: {
                            backgroundColor: '#F4F7FA',
                            width: "16px",

                        },
                        thumb: {
                            backgroundColor: '#F4F7FA',
                            width: "50px",
                            height: "50px"
                        },
                    }}
                    ymin={1}
                    ymax={50}
                    ystep={0.1}
                    axis="y"
                    yreverse
                    y={state.y}
                    onChange={({ y }) => setState(state => ({ ...state, y }))} />
            </div>


        </div >
    )
}

export default CustomSlider;